import dashboard from "./dashboard";
import roles from "./roles";
import { AES, enc } from "crypto-js";
import * as url from "../store/constant/Endpoints";
import permissions from "./permissions";
import domainParameter from "./domainParameter";
import allAssignPermissions from "./allAssignPermissions";
import users from "./allusers";
import reportingHub from "./allReportingHub";
import documentLibrary from "./documentLibrary";
import settings from "./settings";




let permissionUser = localStorage.getItem("data");

let decryptedData = null;
if (permissionUser) {
  try {
    decryptedData = AES.decrypt(permissionUser, url.encryptionSecret).toString(
      enc.Utf8
    );
  } catch (error) {
    localStorage.clear();
    window.location.reload();
  }
}

const permissionsAssrray = decryptedData && JSON.parse(decryptedData);
const menuItems = {
  items: [
    ...(permissionsAssrray?.role_name === "Users"
      ? []
      : dashboard
        ? [dashboard]
        : []),
    ...(domainParameter ? [domainParameter] : []),
    // ...(roles ? [roles] : []),
    // ...(reportingHub ? [reportingHub] : []),
    ...(documentLibrary ? [documentLibrary] : []),

    ...(settings ? [settings] : []),

    // ...(allAssignPermissions ? [allAssignPermissions] : []),
    ...(users ? [users] : []),
  ].filter(Boolean),
};

export default menuItems;
